import React, { useEffect } from "react";

import { TouchableOpacity, View, StyleSheet, Image } from "react-native";
import DefaultText from "../../../components/text/DefaultText";

const ProfileMainScreen = (props) => {
  return (
    <View style={styles.screen}>
      <View style={styles.imageContainer}>
        <Image
          style={styles.image}
          source={require("../../../../assets/Authentik.png")}
        />
      </View>
      <DefaultText style={styles.textContainer}>
        Log in or sign up to cast your NFT
      </DefaultText>

      <TouchableOpacity
        style={styles.buttonContainer}
        onPress={() => {
          props.navigation.navigate("ProfileAuthScreen", {
            isSignup: false,
          });
        }}
      >
        <DefaultText style={styles.buttonText}>Log In</DefaultText>
      </TouchableOpacity>

      <TouchableOpacity
        style={styles.buttonContainer}
        onPress={() => {
          props.navigation.navigate("ProfileAuthScreen", {
            isSignup: true,
          });
        }}
      >
        <DefaultText style={styles.buttonText}>Sign Up</DefaultText>
      </TouchableOpacity>

      <DefaultText style={styles.textContainer}>
        By continuing, you agree to our{" "}
        <DefaultText
          style={styles.textLink}
          onPress={() => {
            console.log("HI");
            props.navigation.navigate("ProfileTermScreen");
          }}
        >
          terms of use
        </DefaultText>{" "}
        and{" "}
        <DefaultText
          style={styles.textLink}
          onPress={() => {
            props.navigation.navigate("ProfilePrivacyScreen");
          }}
        >
          privacy policy
        </DefaultText>
      </DefaultText>
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    flex: 1,
  },
  imageContainer: {
    width: "80%",
    height: "40%",
    aspectRatio: 1,
  },
  image: {
    height: "100%",
    width: "100%",
    resizeMode: "contain",
  },
  buttonContainer: {
    borderWidth: 1,
    paddingVertical: 16,
    marginVertical: 6,
    width: "90%",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    borderColor: "white",
  },

  buttonText: {
    fontSize: 16,
  },
  textContainer: {
    marginVertical: 16,
  },
  textLink: {
    textDecorationLine: "underline",
  },
});

export default ProfileMainScreen;
